import { RefObject } from 'react';

/** Returns current value if refOrValue is RefObject otherwise returns itself  */
export const getRefValue = <Value>(
  refOrValue: RefObject<Value> | Value | null,
): Value | null =>
  refOrValue && typeof refOrValue === 'object' && 'current' in refOrValue
    ? refOrValue.current
    : refOrValue;
